// src/router/guards.js
// Auth0 navigation guards for Vue Router

import { watchEffect } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';

/**
 * Global beforeEach guard.
 * 1. Waits for Auth0 to finish loading the session.
 * 2. Blocks /admin for non-admin users.
 * 3. Updates the document title from route.meta.title.
 */
export async function authGuardBeforeEach(to, from, next) {
  const { isLoading, isAuthenticated, user } = useAuth0();

  // Wait for Auth0 to resolve the session
  if (isLoading.value) {
    await new Promise((resolve) => {
      const stop = watchEffect(() => {
        if (!isLoading.value) {
          stop();
          resolve();
        }
      });
    });
  }

  // RBAC: Admin-only routes
  const roles = user.value?.['https://blything.co.uk/roles'] || [];
  const isAdmin = isAuthenticated.value && roles.includes('Admin');

  if (to.meta.requiresAdmin && !isAdmin) {
    return next('/');
  }

  // Update browser tab title
  document.title = to.meta.title || 'Blything';

  next();
}
